import { CART_TOKEN_KEY } from '@medical/constant'
import { cloudWatchLogger } from '@medical/libs'
import { VALIDATE_CART_SHIFTS } from '@medical/pages/doctor/DoctorCart/DoctorCart.graphql'

export const SET_CART = 'SET_CART'
export const ADD_ITEM = 'ADD_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'

export const cleanInvalidCartItems = apolloClient => async dispatch => {
  const items = JSON.parse(localStorage.getItem(CART_TOKEN_KEY)) || []
  if (items.length === 0) return
  try {
    const { data } = await apolloClient.query({
      query: VALIDATE_CART_SHIFTS,
      variables: { ids: items.map(i => i.id) },
      fetchPolicy: 'network-only',
    })
    const validIds = new Set(data?.validateCartShifts || [])
    const filtered = items.filter(i => validIds.has(i.id))
    if (filtered.length !== items.length) {
      localStorage.setItem(CART_TOKEN_KEY, JSON.stringify(filtered))
      dispatch({ type: SET_CART, payload: filtered })
    }
  } catch (error) {
    cloudWatchLogger().error({
      level: 'ERROR',
      detail: 'VALIDATE_CART_FAILED',
      urlError: window.location.href,
    })
  }
}

export const addItem = item => dispatch => {
  const storageItems = localStorage.getItem(CART_TOKEN_KEY)
  const items = JSON.parse(storageItems) || []
  items.push(item)
  localStorage.setItem(CART_TOKEN_KEY, JSON.stringify(items))
  dispatch({
    type: ADD_ITEM,
    payload: item,
  })
}

export const removeItem = availableShiftId => dispatch => {
  const storageItems = localStorage.getItem(CART_TOKEN_KEY)
  const items = JSON.parse(storageItems) || []
  const newItems = items.filter(item => item.id !== availableShiftId)
  localStorage.setItem(CART_TOKEN_KEY, JSON.stringify(newItems))
  dispatch({
    type: REMOVE_ITEM,
    payload: newItems,
  })
}
